/* v8 ignore start */
import {LottieBlendMode} from "@/lib/lottie/constants/lottieBlendMode";
import {LottieMatteMode} from "@/lib/lottie/constants/lottieMatteMode";
import {TIntBoolean} from "@/lib/lottie/helpers/intBoolean";
import {LottieMaskPropertyModel} from "@/lib/lottie/helpers/lottieMaskPropertyModel";
import {LottieTransformModel} from "@/lib/lottie/helpers/lottieTransformModel";
import {LottieLayerModel} from "@/lib/lottie/layers/lottieLayerModel";

export class LottieVisualLayerModel<
  T extends LottieVisualLayerModel.IJson = LottieVisualLayerModel.IJson,
> extends LottieLayerModel<T> {
  public get transform(): LottieTransformModel {
    return new LottieTransformModel(this.json.ks);
  }

  public adjustTimingBy(factor: number) {
    return super.adjustTimingBy(factor).update({
      ks: this.transform.adjustTimingBy(factor).toObject(),
      masksProperties: this.json.masksProperties?.map((mask) =>
        new LottieMaskPropertyModel(mask).adjustTimingBy(factor).toObject()
      ),
    } as Partial<T>);
  }

  public offsetTimingBy(offset: number) {
    return super.offsetTimingBy(offset).update({
      ks: this.transform.offsetTimingsBy(offset).toObject(),
    } as Partial<T>);
  }
}

export namespace LottieVisualLayerModel {
  export interface IJson extends LottieLayerModel.IJson {
    /**
     * Layer transform
     */
    ks: LottieTransformModel.IJson;

    /**
     * If 1, The layer will rotate itself to match its animated position path
     * @default 0
     */
    ao?: TIntBoolean;

    /**
     * Defines the track matte mode for the layer
     */
    tt?: LottieMatteMode;

    /**
     * Index of the layer used as matte, if omitted assume the layer above the current one
     */
    tp?: number;

    /**
     * If set to 1, it means a layer is using this layer as a track matte
     */
    td?: TIntBoolean;

    /**
     * Whether the layer has masks applied
     */
    hasMask?: boolean;

    /**
     * List of layer masks
     */
    masksProperties?: LottieMaskPropertyModel.IJson[];

    /**
     * [Not used] List of layer effects
     */
    // ef?: any[];

    /**
     * Whether motion blur is enabled for the layer
     */
    mb?: boolean;

    /**
     * [Not used] Styling effects for this layer
     */
    sy?: any[];

    /**
     * Blend Mode
     * @default 0
     */
    bm?: LottieBlendMode;

    /**
     * CSS class used by the SVG renderer
     */
    cl?: string;

    /**
     * `id` attribute used by the SVG renderer
     */
    ln?: string;

    /**
     * tag name used by the SVG renderer
     */
    tg?: string;

    /**
     * Marks that transforms should be applied before masks
     * @default 0
     */
    ct?: TIntBoolean;
  }
}
/* v8 ignore stop */
